
export default {
  computed: {
    cloudPath () {
      return this.$page.props.brand === 'SBL'
        ? 'https://storage.googleapis.com/revo-sbl-bucket/xef'
        : 'https://storage.googleapis.com/revo-cloud-bucket/xef'
    },
  },

  methods: {
    imgSrc (photo, size = 100) {
      return photo === null || photo.toLowerCase().startsWith('http')
        ? photo
        : `${this.cloudPath}/${this.$page.props.auth.tenant}/images/resized_${size}_${photo}`
    },
  },
}
